module.exports = __webpack_public_path__ + "static/media/characterDesign-01.85360fc4.jpg";